(function () {
  'use strict';

  function init() {
    initReviews();
    initStandardCarousel();
    initCrossSellCarousel();
  }

  // ---------- SECTION 5: reviews ----------
  function initReviews() {
    var row = document.getElementById('s5-row');
    var prev = document.getElementById('s5-prev');
    var next = document.getElementById('s5-next');
    if (!row || !prev || !next) return;

    var seeds = Array.prototype.slice.call(row.querySelectorAll('.review[data-seed]'));
    if (seeds.length === 0) return;

    var REVIEWS = seeds.map(function (el) {
      return {
        stars: parseInt(el.getAttribute('data-stars'), 10) || 5,
        text: el.getAttribute('data-text') || '',
        name: el.getAttribute('data-name') || '',
        initial: el.getAttribute('data-initial') || ''
      };
    });

    var starSVG =
      '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>';
    var checkSVG =
      '<svg viewBox="0 0 12 12"><path d="M6 0C2.69 0 0 2.69 0 6c0 3.31 2.69 6 6 6s6-2.69 6-6c0-3.31-2.69-6-6-6zm3.35 4.42L5.52 8.23a.59.59 0 0 1-.83.01L2.66 6.39a.55.55 0 0 1-.04-.84.59.59 0 0 1 .84.03l1.61 1.47 3.43-3.43c.24-.24.62-.24.86 0 .24.24.24.62 0 .8z"/></svg>';

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function reviewCard(r) {
      var stars = '';
      for (var i = 0; i < r.stars; i++) stars += starSVG;
      return (
        '<div class="review">' +
          '<div class="review__stars">' + stars + '</div>' +
          '<p class="review__text">' + r.text + '</p>' +
          '<div class="review__person">' +
            '<div class="review__avatar">' + escapeHtml(r.initial) + '</div>' +
            '<div class="review__meta">' +
              '<p class="review__name">' + escapeHtml(r.name) + '</p>' +
              '<div class="review__verified">' + checkSVG + '<span>Verified Customer</span></div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    var offset = 0;
    var visible = 4;

    function render() {
      var out = [];
      var n = Math.min(visible, REVIEWS.length);
      for (var i = 0; i < n; i++) {
        out.push(reviewCard(REVIEWS[(offset + i) % REVIEWS.length]));
      }
      row.innerHTML = out.join('');
    }

    render();

    prev.addEventListener('click', function () {
      offset = (offset - 1 + REVIEWS.length) % REVIEWS.length;
      render();
    });
    next.addEventListener('click', function () {
      offset = (offset + 1) % REVIEWS.length;
      render();
    });
  }

  // ---------- SECTION 4: mobile carousel ----------
  function initStandardCarousel() {
    var track = document.getElementById('s4-track');
    if (!track) return;
    var dots = Array.prototype.slice.call(document.querySelectorAll('#s4-dots .s4__dot'));
    if (dots.length === 0) return;

    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / (track.clientWidth * 0.85 + 16));
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
    });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (track.children[i]) {
          track.children[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });
  }

  // ---------- SECTION 6: cross-sell carousel ----------
  function initCrossSellCarousel() {
    var carousel = document.getElementById('s6-carousel');
    if (!carousel) return;
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.s6__slide'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('.s6__dot'));
    var prev = document.getElementById('s6-prev');
    var next = document.getElementById('s6-next');
    if (slides.length === 0) return;

    var idx = 0;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }

    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });

    setInterval(function () { go(idx + 1); }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
